export default __webpack_public_path__ + "static/dropshippingVp1-06480a60be520bb69249824f91a377e1.png";